export const data = { content:"{\"openapi\":\"3.1.1\",\"info\":{\"title\":\"CrmPublicApi\",\"version\":\"1.0\"},\"servers\":[{\"url\":\"https://staging.public.api.crm.safemgr.com/\",\"description\":\"A staging server url\"}],\"security\":[{\"ApiKeyAuth\":[]}],\"paths\":{\"/customers\":{\"post\":{\"tags\":[\"Customer\"],\"requestBody\":{\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CustomerCreateModel\"}}}},\"responses\":{\"200\":{\"description\":\"Success\",\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CustomerModel\"}}}}}}},\"/customers/{id}/events\":{\"post\":{\"tags\":[\"Customer\"],\"parameters\":[{\"name\":\"id\",\"in\":\"path\",\"required\":true,\"schema\":{\"type\":\"string\",\"format\":\"uuid\"}}],\"requestBody\":{\"content\":{\"application/json\":{\"schema\":{\"$ref\":\"#/components/schemas/CustomerEventCreateModel\"}}}},\"responses\":{\"200\":{\"description\":\"Success\"}}}}},\"components\":{\"securitySchemes\":{\"ApiKeyAuth\":{\"type\":\"apiKey\",\"in\":\"header\",\"name\":\"X-Api-Key\"}},\"schemas\":{\"AddressModel\":{\"type\":\"object\",\"properties\":{\"firstname\":{\"type\":[\"string\",\"null\"]},\"lastname\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"phone\":{\"type\":[\"string\",\"null\"]},\"street\":{\"type\":[\"string\",\"null\"]},\"city\":{\"type\":[\"string\",\"null\"]},\"state\":{\"type\":[\"string\",\"null\"]},\"postalCode\":{\"type\":[\"string\",\"null\"]},\"comment\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"CustomerCreateModel\":{\"type\":\"object\",\"properties\":{\"firstname\":{\"type\":[\"string\",\"null\"]},\"lastname\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"phone\":{\"type\":[\"string\",\"null\"]},\"utmMetadata\":{\"$ref\":\"#/components/schemas/UtmModel\"},\"status\":{\"$ref\":\"#/components/schemas/CustomerStatusModel\"},\"userId\":{\"type\":[\"string\",\"null\"],\"format\":\"uuid\"},\"address\":{\"$ref\":\"#/components/schemas/AddressModel\"},\"properties\":{\"type\":[\"array\",\"null\"],\"items\":{\"$ref\":\"#/components/schemas/PropertyModel\"}}},\"additionalProperties\":false},\"CustomerEventCreateModel\":{\"type\":\"object\",\"properties\":{\"event\":{\"type\":[\"string\",\"null\"]},\"data\":{\"type\":[\"string\",\"null\"]},\"utmData\":{\"$ref\":\"#/components/schemas/UtmModel\"},\"eventDateTime\":{\"type\":\"string\",\"format\":\"date-time\"}},\"additionalProperties\":false},\"CustomerModel\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"createdAt\":{\"type\":\"string\",\"format\":\"date-time\"},\"updatedAt\":{\"type\":\"string\",\"format\":\"date-time\"},\"companyId\":{\"type\":\"string\",\"format\":\"uuid\"},\"firstname\":{\"type\":[\"string\",\"null\"]},\"lastname\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"phone\":{\"type\":[\"string\",\"null\"]},\"utmMetadata\":{\"$ref\":\"#/components/schemas/UtmModel\"},\"statusId\":{\"type\":\"string\",\"format\":\"uuid\"},\"status\":{\"$ref\":\"#/components/schemas/CustomerStatusModel\"}},\"additionalProperties\":false},\"CustomerStatusModel\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"PropertyModel\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":[\"string\",\"null\"]},\"name\":{\"type\":[\"string\",\"null\"]},\"value\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"UtmModel\":{\"type\":\"object\",\"properties\":{\"source\":{\"type\":[\"string\",\"null\"]},\"medium\":{\"type\":[\"string\",\"null\"]},\"campaign\":{\"type\":[\"string\",\"null\"]},\"term\":{\"type\":[\"string\",\"null\"]},\"content\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false},\"VoipStudioCallModel\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":[\"string\",\"null\"]},\"eventTime\":{\"type\":\"string\",\"format\":\"date-time\"},\"eventName\":{\"type\":[\"string\",\"null\"]},\"callId\":{\"type\":\"integer\",\"format\":\"int64\"},\"state\":{\"type\":[\"string\",\"null\"]},\"connectedAt\":{\"type\":\"string\",\"format\":\"date-time\"},\"startTime\":{\"type\":\"string\",\"format\":\"date-time\"},\"context\":{\"type\":[\"string\",\"null\"]},\"destination\":{\"type\":[\"string\",\"null\"]},\"duration\":{\"type\":\"integer\",\"format\":\"int32\"},\"tCause\":{\"type\":[\"string\",\"null\"]},\"src\":{\"type\":[\"string\",\"null\"]},\"srcId\":{\"type\":[\"string\",\"null\"]},\"srcName\":{\"type\":[\"string\",\"null\"]},\"srcHash\":{\"type\":[\"string\",\"null\"]},\"dst\":{\"type\":[\"string\",\"null\"]},\"dstId\":{\"type\":[\"string\",\"null\"]},\"dstName\":{\"type\":[\"string\",\"null\"]},\"terminatedBy\":{\"type\":[\"string\",\"null\"]}},\"additionalProperties\":false}}}}",
  parsed:{ openapi:"3.1.1",
    info:{ title:"CrmPublicApi",
      version:"1.0" },
    servers:[ { url:"https://staging.public.api.crm.safemgr.com/",
        description:"A staging server url" } ],
    security:[ { ApiKeyAuth:[  ] } ],
    paths:{ "/customers":{ post:{ tags:[ "Customer" ],
          requestBody:{ content:{ "application/json":{ schema:{ $ref:"#/components/schemas/CustomerCreateModel" } } } },
          responses:{ 200:{ description:"Success",
              content:{ "application/json":{ schema:{ $ref:"#/components/schemas/CustomerModel" } } } } } } },
      "/customers/{id}/events":{ post:{ tags:[ "Customer" ],
          parameters:[ { name:"id",
              "in":"path",
              required:true,
              schema:{ type:"string",
                format:"uuid" } } ],
          requestBody:{ content:{ "application/json":{ schema:{ $ref:"#/components/schemas/CustomerEventCreateModel" } } } },
          responses:{ 200:{ description:"Success" } } } } },
    components:{ securitySchemes:{ ApiKeyAuth:{ type:"apiKey",
          "in":"header",
          name:"X-Api-Key" } },
      schemas:{ AddressModel:{ type:"object",
          properties:{ firstname:{ type:[ "string",
                "null" ] },
            lastname:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] },
            phone:{ type:[ "string",
                "null" ] },
            street:{ type:[ "string",
                "null" ] },
            city:{ type:[ "string",
                "null" ] },
            state:{ type:[ "string",
                "null" ] },
            postalCode:{ type:[ "string",
                "null" ] },
            comment:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        CustomerCreateModel:{ type:"object",
          properties:{ firstname:{ type:[ "string",
                "null" ] },
            lastname:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] },
            phone:{ type:[ "string",
                "null" ] },
            utmMetadata:{ $ref:"#/components/schemas/UtmModel" },
            status:{ $ref:"#/components/schemas/CustomerStatusModel" },
            userId:{ type:[ "string",
                "null" ],
              format:"uuid" },
            address:{ $ref:"#/components/schemas/AddressModel" },
            properties:{ type:[ "array",
                "null" ],
              items:{ $ref:"#/components/schemas/PropertyModel" } } },
          additionalProperties:false },
        CustomerEventCreateModel:{ type:"object",
          properties:{ event:{ type:[ "string",
                "null" ] },
            data:{ type:[ "string",
                "null" ] },
            utmData:{ $ref:"#/components/schemas/UtmModel" },
            eventDateTime:{ type:"string",
              format:"date-time" } },
          additionalProperties:false },
        CustomerModel:{ type:"object",
          properties:{ id:{ type:"string",
              format:"uuid" },
            createdAt:{ type:"string",
              format:"date-time" },
            updatedAt:{ type:"string",
              format:"date-time" },
            companyId:{ type:"string",
              format:"uuid" },
            firstname:{ type:[ "string",
                "null" ] },
            lastname:{ type:[ "string",
                "null" ] },
            email:{ type:[ "string",
                "null" ] },
            phone:{ type:[ "string",
                "null" ] },
            utmMetadata:{ $ref:"#/components/schemas/UtmModel" },
            statusId:{ type:"string",
              format:"uuid" },
            status:{ $ref:"#/components/schemas/CustomerStatusModel" } },
          additionalProperties:false },
        CustomerStatusModel:{ type:"object",
          properties:{ id:{ type:"string",
              format:"uuid" },
            name:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        PropertyModel:{ type:"object",
          properties:{ id:{ type:[ "string",
                "null" ] },
            name:{ type:[ "string",
                "null" ] },
            value:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        UtmModel:{ type:"object",
          properties:{ source:{ type:[ "string",
                "null" ] },
            medium:{ type:[ "string",
                "null" ] },
            campaign:{ type:[ "string",
                "null" ] },
            term:{ type:[ "string",
                "null" ] },
            content:{ type:[ "string",
                "null" ] } },
          additionalProperties:false },
        VoipStudioCallModel:{ type:"object",
          properties:{ id:{ type:[ "string",
                "null" ] },
            eventTime:{ type:"string",
              format:"date-time" },
            eventName:{ type:[ "string",
                "null" ] },
            callId:{ type:"integer",
              format:"int64" },
            state:{ type:[ "string",
                "null" ] },
            connectedAt:{ type:"string",
              format:"date-time" },
            startTime:{ type:"string",
              format:"date-time" },
            context:{ type:[ "string",
                "null" ] },
            destination:{ type:[ "string",
                "null" ] },
            duration:{ type:"integer",
              format:"int32" },
            tCause:{ type:[ "string",
                "null" ] },
            src:{ type:[ "string",
                "null" ] },
            srcId:{ type:[ "string",
                "null" ] },
            srcName:{ type:[ "string",
                "null" ] },
            srcHash:{ type:[ "string",
                "null" ] },
            dst:{ type:[ "string",
                "null" ] },
            dstId:{ type:[ "string",
                "null" ] },
            dstName:{ type:[ "string",
                "null" ] },
            terminatedBy:{ type:[ "string",
                "null" ] } },
          additionalProperties:false } } } } }